export default {
  wblcategory: {
    columnlist: "Danh sách cột",
    create: "Tạo mới danh mục White Black List",
    name: "Tên",
    targettable: "Bảng Đích",
    title: "Danh Mục White/Black",
    update: "Cập nhật White Black List",
    choose_columnlist: "Chọn danh sách cột"
  },
}